import { render, staticRenderFns } from "./phrase_edit.vue?vue&type=template&id=f86e916e&"
import script from "./phrase_edit.vue?vue&type=script&lang=ts&"
export * from "./phrase_edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports